import { produce } from 'immer';

import { SaveInternalBanners } from '../../../actions/bannersEdit/internal/saveInternalBanners';
import { PageStatus } from '../../../typings/common';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function saveInternalBanners(
    state: EditInternalBannersState,
    action: SaveInternalBanners
): EditInternalBannersState {
    return produce(state, draft => {
        draft.pageStatus = PageStatus.SAVING;
        draft.errorsSummary = {};
        draft.errors = [];
    });
}
